import {
  addDays,
  addMonths,
  startOfMonth,
  subDays,
  subMonths,
} from 'date-fns';

const DIFF_RE = /([dm])(\+|-)(\d+)/;

export default function simpleDiffToDate(dateDiff: string): Date {
  const deltaMatch = dateDiff.match(DIFF_RE);

  if (!deltaMatch) return new Date();

  const isMonthDiff = deltaMatch[1] === 'm';
  const shouldAddOffset = deltaMatch[2] === '+';
  const diff = Number(deltaMatch[3]);

  if (isMonthDiff) {
    const refDate = startOfMonth(new Date());
    return shouldAddOffset ? addMonths(refDate, diff) : subMonths(refDate, diff);
  }
  return shouldAddOffset ? addDays(new Date(), diff) : subDays(new Date(), diff);
}
